import * as React from 'react';
import { Link } from 'react-router';

import * as $ from 'jquery';
import * as _ from 'underscore';

import Synopsis from './Synopsis';
import Agenda from '../widgets/Agenda';
import Layout from '../Layout';

export default class Index extends React.Component<{}, {}> {

    render() {
        return (
            <Layout id="room-index"
                    title="Make Your Reservations"
                    subtitle="Your can find it all here at iBeachResort"
                    background="/images/scroll.jpg">

              <Agenda />

              <div className="row">
                <div className="six wide center aligned centered column">
                  <h2>Rooms Available</h2>
                  <p>
                    At the iBeachResort Resort Hotel we have a total of
                    16 guest rooms. All of our rooms are accommodated
                    with 40" televisions, complimentary wireless internet,
                    refrigerators, microwaves and much more. You can
                    choose from three different styles of rooms to
                    best accommodate you during your stay.
                    On-site guest laundry, barbeque grills, heated pool,
                    ice machine, and complimentary coffee daily.
                    <small style={{ display: 'block', fontSize: '14px', fontWeight: 'bold' }}>
                      (One Parking Spot Per Room)
                    </small>
                  </p>
                </div>
              </div>

              <div className="row" style={ { marginTop: '55px' } }>
                <Synopsis folding={ true } />
              </div>

              <div className="row">
                <div className="ten wide column">
                  <img id="outlook" src="/images/outlook.jpg" />
                </div>
              </div>
              <div className="row">
                <div className="nine wide column">
                  <h2>Walk to the Beach</h2>
                  <p>
                    The beautiful blue waves of the Gulf of Mexico
                    are a short walk from your room. While
                    staying at the iBeachResort you will
                    receive exceptional hospitality service
                    and a relaxing escape just steps away from the beach.
                  </p>
                </div>
              </div>
            </Layout>
        );
    }

}



/** WEBPACK FOOTER **
 ** ./src/components/rooms/Index.tsx
 **/